import { boundedPromise } from "#bounded-promise";
import type { Deadline } from "#deadline-ms";

/**
 * Await `run` for at most `deadline`. On expiry the awaiter receives a `DeadlineExceededError`
 * and `signal` aborts, so the operation can stop (fetch, AbortSignal-aware SDKs). Work that cannot
 * observe the signal keeps running unobserved; its late result or error is discarded.
 *
 * Use this at every await whose settlement depends on something outside this process's control —
 * the network, a native module, another tab or worker, a lock held by someone else.
 */
export function withDeadline<T>(
  options: { deadline: Deadline; operation: string },
  run: (signal: AbortSignal) => Promise<T>,
): Promise<T> {
  return boundedPromise<T>(options, (resolve, reject, signal) => {
    run(signal).then(resolve, reject);
  });
}
